import React, { createContext, useContext, useEffect, useState } from "react";
import { getCookie, setCookie, removeCookie } from "../Helpers/Utils";
import Handler from '../Helpers/Handler'

const AuthContext = createContext();

function AuthenticateProvider({ children }) {

  const logIn = (token) => {
    setCookie("token", token);
    setIsAuthenticated(true);
  };
  const token = getCookie("token")
  const [isAuthenticated, setIsAuthenticated] = useState(token);
  const [profileDetails, setProfileDetails] = useState({})
  const [loading, setLoading] = useState(false)

  const logOut = () => {
    setIsAuthenticated(false);
    removeCookie('token')
  };
  const getProfile = async () => {
    const response = await Handler({ method: 'GET', url: `/customer/details` })
    if (response?.success) {
      setProfileDetails((prev) => ({ ...response.data, cust_name: response?.data?.firstName, cust_photo: response?.data?.photo }));
      setLoading(true)
    }
  }

  useEffect(() => {
    if (token) {
      setIsAuthenticated(true);
      getProfile()
    }
  }, [token]);

  return (
    <AuthContext.Provider value={{ logIn, logOut, isAuthenticated, profileDetails, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthenticateProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
